import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js"; // 粉丝自销页面路由

var FansShowHome = function FansShowHome() {
  return import('@/pages/fans/fans.vue');
};

export default [{
  //  flive ==> fans-live 粉丝现场
  path: '/flive',
  component: FansShowHome,
  children: [{
    // 演出列表页
    path: '',
    name: 'fansShowHome',
    component: FansShowHome
  }, {
    // 演出列表页
    path: 'list',
    name: 'fansShowList',
    component: function component() {
      return import('@/pages/fans/list/list');
    }
  }, {
    // 演出详情页面
    path: 'detail/:pId',
    name: 'fansShowDetail',
    component: function component() {
      return import('@/pages/fans/detail/detail.vue');
    }
  }, {
    // 票品选择页
    path: 'tickets/:pId',
    name: 'fansShowTickets',
    component: function component() {
      return import('@/pages/fans/ticket/ticket');
    }
  }, {
    // 确认订单页
    // data 参数处理为 base64 (做一次简单的掩码)
    // data: { pId, sId, aId, seat, tIds, salesId }
    path: 'order-confirm/:data',
    name: 'fansShowOrderConfirm',
    component: function component() {
      return import('@/pages/fans/order/confirm/confirm');
    }
  }, {
    // 订单详情页
    path: 'order-detail',
    name: 'fansShowOrderDetail',
    component: function component() {
      return import('@/pages/fans/order/detail/detail');
    }
  }, {
    // 订单列表页
    path: 'order-list',
    name: 'fansShowOrderList',
    component: function component() {
      return import('@/pages/fans/order/list/list');
    }
  }, {
    // 实名列表
    path: 'realnames',
    name: 'fansRealNames',
    meta: {
      title: '观演人管理'
    },
    component: function component() {
      return import('fans/realnames/realnames');
    }
  }, {
    // 抽签活动列表页
    path: 'draw-activity-list',
    name: 'activityList',
    component: function component() {
      return import('@/pages/fans/activity/list/index');
    }
  }, {
    // 活动详情页
    path: 'activity-detail/:id',
    name: 'activityDetail',
    meta: {
      detail: true
    },
    component: function component() {
      return import('@/pages/fans/activity/detail/index');
    }
  }, {
    // 活动报名结果页
    path: 'signUp-result/:id',
    name: 'signUpDetail',
    meta: {
      result: true
    },
    component: function component() {
      return import('@/pages/fans/activity/result/index');
    }
  }, {
    // 报名订单列表
    path: 'signUp-list',
    name: 'signUpList',
    meta: {
      result: true
    },
    component: function component() {
      return import('@/pages/fans/activity/list/sign-up-list');
    }
  }]
}];